import { PaginationAndSorting } from './pagination-and-sorting-model';

export class SupplierDiscountFilters extends PaginationAndSorting {
  filter: string = undefined;
}
